import { useState, useRef } from "react";

export function MenuShowCaseAccordion({ data }) {
  const [openIndex, setOpenIndex] = useState(0);
  const itemRefs = useRef([]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
    if (openIndex !== index) {
      setTimeout(() => {
        if (itemRefs.current[index]) {
          const headerOffset = 80;
          const elementPosition =
            itemRefs.current[index].getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.scrollY - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 10);
    }
  };

  return (
    <section className="bg-light-blue-grey mobile-accordion">
      <div className="container md:d-block lg:d-none md:pb-10">
        <h2 className="text-lg mb-5">{data.heading}</h2>
        {data.items.map((sec, index) => (
          <div key={index} className="mb-1 bp-accordion-item">
            <button
              className="fx fx--sb w-100 menu mb-1"
              onClick={() => toggleAccordion(index)}
              aria-expanded={openIndex === index}
              ref={(el) => (itemRefs.current[index] = el)}
            >
              <p className="menu-item">{sec.title}</p>
              <span
                className="ml-auto"
                dangerouslySetInnerHTML={{ __html: sec.icon }}
              />
            </button>
            <article
              key={sec.id}
              className={`share-options-content ${
                openIndex === sec.id ? "showoption" : ""
              }`}
              aria-hidden={openIndex !== index}
              data-content={sec.id}
            >
              <h2 className="mb-2">{sec.heading}</h2>
              {Array.isArray(sec.desc) ? (
                sec.desc.map((desc, index) => (
                  <p
                    className="mb-2"
                    dangerouslySetInnerHTML={{ __html: desc }}
                    key={index}
                  />
                ))
              ) : (
                <p
                  className="mb-2"
                  dangerouslySetInnerHTML={{ __html: sec.desc }}
                />
              )}
              {sec.note && (
                <p
                  className="mb-3"
                  dangerouslySetInnerHTML={{ __html: sec.note }}
                />
              )}
              {sec.list && (
                <ul className="lg:px-4 mb-3">
                  {sec.list.map((listItem, listIndex) => (
                    <li
                      className="mb-1 show-case-list-item"
                      dangerouslySetInnerHTML={{ __html: listItem }}
                      key={listIndex}
                    />
                  ))}
                </ul>
              )}
              <div className="bg-light-blue-grey img-container">
                <img src={`${sec.src}`} alt="Booking Preview" width="100%" />
              </div>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
}
